import React from 'react';
import '../template-file-css/document-file-template.css';


export const RPBS_ConsentForTreatment = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='RPBS_ConsentForTreatment' className='file-pdf-document'>
            <div className='file-template'>
            <p className='w-750'><h3>Consent for Treatment</h3></p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Client Name:</span>
                        </td>
                        <td className='w-375'><span className='eleHeader'>Medicaid #</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtClient' name='txtClient' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtMedicaid' name='txtMedicaid' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>DOB:</span>
                        </td>
                        <td className='w-375'><span className='eleHeader'>Address:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='date' id='txtDob' name='txtDob' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtAddress' name='txtAddress' className='add-only' /></td>
                    </tr>
                </table>
                <p className='w-750'>I understand that as a client of Right Path Behavioral Health Services (RPBHS) or as a parent/guardian of a RPBHS client, I or my child/ward am/is eligible to receive a range of services. The type and extent of s'ervices I or my child/ward will receive is determined via an initial assessment and a detailed discussion with me and my child/ward and may include individual and family therapy, psychosocial rehabilitation, targeted case management, and/or psychiatric/medication management services. The goal of the assessment process is to determine the best course of treatment for my child/ward 0 I me. Typically, treatment is provided over the course of several months.</p>
                <p className='w-750'>
                    During the course of treatment at RPBHS, it may be necessary for members of my treatment team to communicate with one another. Also, it will be necessary to provide information with employees, supervisors or directors at RPBHS. I understand that while all information about my child/ward or me is confidential, sharing this information across providers and administrative staff within RPBHS does not
                    breech confidentiality. However, no information about me or my child/ward will be released outside of RPBHS without my written consent. Verbal consent for limited release information may be permitted and/or necessary in in special circumstances. I further understand that there are specific and limited exceptions to this
                    confidentiality, which include the following:
                </p>
                <p className='w-750'>
                <ol type='A'>
                    <li>When there is a risk of imminent danger to myself, my child/ward, or to another person, the clinician is ethically bound to take necessary steps to prevent such danger.</li>
                    <li>When there is suspicion that a vulnerable adult or child is being sexually or physically abused or is at risk of such abuse, the clinician is legally required to take steps to protect the individual and to inform the proper authorities.</li>
                    <li>When a valid court order such as a subpoena is issued for medical records, the clinician and the agency are bound by law to comply with such requests.</li>
                </ol>
                </p>
                <p className='w-750'>I understand that a range of mental health professionals, some of whom are in training, provide rehabilitative mental health services, counseling, and therapy. Licensed staff supervise all professionals- in-training.</p>
                <p className='w-750'>Explanation of risks and benetifs of the proposed treatment, of alternative treatments, or of no treatment</p>
                <p className='w-750'>
                    I understand that while RPBHS may provide significant benefits, it may also pose risks. RPBHS may also
                    eIlicit uncomfortable thoughts and feelings, or may lead to the recall of troubling memories. However, I understand that without such treatment my or my child's/wardâ€˜s condition may worsen. The duration of
                    these services will be in place until treatment goals have been achieved, or until either party gives notice.
                </p>
                <p className='w-750'>I| understand that the treatment may be ordered by the court or the referring agency as part of a treatment plan. Refusal to take part in such treatment may result in legal ramifications or removal from the program.</p>
                <p className='w-750'>
                    I have read and understand the above. I consent to participate or for my child/ward to participate in the evaluation and treatment offered by RPBHS. I give consent for RPBHS to provide the treatments explained above. By signing below, I also acknowledge that my file or my childâ€™s/wardâ€™s file could be pulled as part of a random audit to assess compliance. I acknowledge understanding that these assessments are conducted confidentially and without any conflict of interest. If I have questions regarding this consent form or about the services offered at RPBHS, I may discuss them with members of my treatment team and or members of RPBHS administration team. I understand that I may refuse treatment in full or in part at any time.
                </p>
                <h3>RPBHS Responses:</h3>
                <p className='w-750'>
                    <span className='eleHeader'>1.  Reaffirmation of the client's right to refuse</span>
                    <input type='radio' id='rb_10_1' name='rb_10' className='add-only' value='1' /> Yes&nbsp;
                    <input type='radio' id='rb_10_2' name='rb_10' className='add-only' value='2' /> No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>2.  Alternative service(s) collaboratively discussed</span>
                    <input type='radio' id='rb_101_1' name='rb_101' className='add-only' value='1' /> Yes&nbsp;
                    <input type='radio' id='rb_101_2' name='rb_101' className='add-only' value='2' /> No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>3.  Effort to ensure Client understands consequences of refusing/withdrawing consent </span>
                    <input type='radio' id='rb_102_1' name='rb_102' className='add-only' value='1' /> Yes&nbsp;
                    <input type='radio' id='rb_102_2' name='rb_102' className='add-only' value='2' /> No
                </p>

                
            </div>
        </form>

    )
}











